export const CHART_SUBTYPES = ['vbar', 'vgbar', 'hbar', 'hgbar', 'line', 'multiline', 'pie', 'heatmap', 'treemap'] as const;
export const CHART_TYPES = ['bar', 'line', 'pie', 'heatmap', 'treemap'] as const
export const CHART_CONFIG_KEY = ['vbar', 'hbar', 'line', 'pie'] as const;
export const MAP_SUBTYPES = ['censusChartMap', 'censusMapbox'] as const;
export const MAP_FACADE_KEYS = ['mapbox', 'chartMap'] as const;
export const KPI_SUBTYPES = ['kpi'] as const;
export const TABLE_SUBTYPES = ['table'] as const;
export const COMPARISON_SUBTYPE = ['comparison'] as const;
export const ASPECT_CARD_SUBTYPE = ['aspectCard'] as const;
export const MAP_LIST_FACADE_KEYS = ['mapList'] as const;
export const COMPARISON_MAP_FACADE_KEYS = ['comparisonMap'] as const;
export const INDICATOR_FLAT_CARD_FACADE_KEYS = ['indicatorFlatCard'] as const;
export const INDICATOR_KPI_FACADE_KEYS = ['indicatorKpi'] as const;
export const INDICATOR_RANK_FACADE_KEYS = ['indicatorRank'] as const;
export const TIME_SERIES_CHART_FACADE_KEYS = ['timeSeriesChart'] as const;
export const INDICATOR_DETAILS_FACADE_KEYS = ['indicatorDetails'] as const;

export const VIZ_SUBTYPES = [
  ...CHART_SUBTYPES,
  ...MAP_SUBTYPES,
  ...KPI_SUBTYPES,
  ...TABLE_SUBTYPES,
] as const;

export const FACADE_KEYS = [
  'chart',
  ...MAP_FACADE_KEYS,
  ...KPI_SUBTYPES,
  ...TABLE_SUBTYPES,
  ...COMPARISON_SUBTYPE,
  ...ASPECT_CARD_SUBTYPE,
  ...MAP_LIST_FACADE_KEYS,
  ...COMPARISON_MAP_FACADE_KEYS,
  ...INDICATOR_FLAT_CARD_FACADE_KEYS,
  ...INDICATOR_KPI_FACADE_KEYS,
  ...INDICATOR_RANK_FACADE_KEYS,
  ...TIME_SERIES_CHART_FACADE_KEYS,
  ...INDICATOR_DETAILS_FACADE_KEYS,
] as const;

export type ChartSubtype = (typeof CHART_SUBTYPES)[number];
export type ChartType = (typeof CHART_TYPES)[number];
export type ChartConfigKey = (typeof CHART_CONFIG_KEY)[number];
export type MapSubtype = (typeof MAP_SUBTYPES)[number];
export type KpiSubtype = (typeof KPI_SUBTYPES)[number];
export type TableSubtype = (typeof TABLE_SUBTYPES)[number];
export type MapFacadeKey = (typeof MAP_FACADE_KEYS)[number];
export type VizSubtype = (typeof VIZ_SUBTYPES)[number];
export type ComparisonSubtype = (typeof COMPARISON_SUBTYPE)[number];
export type AspectCardSubtype = (typeof ASPECT_CARD_SUBTYPE)[number];
export type FacadeKey = (typeof FACADE_KEYS)[number];

export function getChartTypeFromSubtype(subtype: ChartSubtype): ChartType {
  switch (subtype) {
    case 'vbar':
    case 'vgbar':
    case 'hbar':
    case 'hgbar':
      return 'bar';
    case 'line':
    case 'multiline':
      return 'line';
    case 'pie':
      return 'pie';
    case 'heatmap':
      return 'heatmap';
    case 'treemap':
      return 'treemap';
  }
}

export function getChartConfigKeyFromSubtype(subtype: ChartSubtype): ChartConfigKey {
  switch (subtype) {
    case 'vbar':
    case 'vgbar':
      return 'vbar';
    case 'hbar':
    case 'hgbar':
      return 'hbar';
    case 'line':
    case 'multiline':
    case 'heatmap':
      return 'line';
    case 'pie':
    case 'treemap':
      return 'pie';
  }
}

export function isVizSubType(value: string): value is VizSubtype {
  return (VIZ_SUBTYPES as readonly string[]).includes(value);
}

export function isFacadeKey(value: string): value is FacadeKey {
  return (FACADE_KEYS as readonly string[]).includes(value);
}
